import { Company, DateType } from 'api/models';
import { VisibilityType } from 'api/project';
import { ProjectInUserProfile } from 'api/user';

export class Project implements ProjectInUserProfile {
  projectId: number;

  projectName: string;

  customer: Company;

  visibility: VisibilityType;

  startDate: DateType;

  dueDate: DateType;

  constructor(project: ProjectInUserProfile) {
    this.projectId = project.projectId;
    this.projectName = project.projectName;
    this.customer = project.customer;
    this.visibility = project.visibility;
    this.startDate = project.startDate;
    this.dueDate = project.dueDate;
  }
}
